import { useRouter } from "next/router";
import { clearFalsyKeysFromObject } from "@/utils/global";

const useFilterData = () => {
    const router = useRouter();
    const { pathname, query } = router;

    const getFilterObj = { ...query };

    const setFilterQueryHandler = (obj) => {
        const finalObj = { ...getFilterObj, ...obj };
        const modifiedObj = clearFalsyKeysFromObject(finalObj);
        console.log({ test: modifiedObj });

        router.push({ pathname, query: modifiedObj }, undefined, {
            shallow: true,
            scroll: false,
        });
    };

    const resetFilterQueryHandler = () => {
        router.push({ pathname, query: {} }, undefined, {
            shallow: true,
            scroll: false,
        });
    };

    return {
        getFilterObj,
        setFilterQueryHandler,
        resetFilterQueryHandler,
    };
};

export default useFilterData;
